import { deleteSubscribe, subscribeList, addSubscribe } from '@/service'
const entity_temp_mixins = {
  inject: ['haddleApplyTry'],
  computed: {
    attention_list() {
      return this.$store.state.attention || {}
    },
    atten_item() {
      let index = this.$store.state.attention.subscribe.findIndex(a => a.sub_type == this.entitytype && this.item.id == a.sub_type_id)
      if (index > -1) {
        return this.$store.state.attention.subscribe[index]
      } else {
        return ''
      }
    }
  },
  methods: {
    handleClickEntity() {
      if(this.entitytype == 0) {
        this.$parent.active_id = this.item.id
        this.$parent.active_uid = this.item.uid
        this.$parent.getCompDetail(this.item.id)
        _czc.push(['_trackEvent', '我的关注(新)', '关注的公司(关注一览公司选择)', '点击量'])
      } else {
        this.$parent.active_uid = this.item.uid
        this.$parent.active_id = this.item.id
        this.$parent.active_item = this.item
        this.$parent.getDetail(this.item.uid)
        _czc.push(['_trackEvent', '我的关注(新)', '关注的机构(关注一览机构选择)', '点击量'])
      }
    },
    handleClickAtten(pos) {
      if(pos) {
        if( pos == 1 ) _czc.push(['_trackEvent', '我的关注(新)', '你可能感兴趣(推荐公司_关注)', '点击量'])
        if( pos == 2 ) _czc.push(['_trackEvent', '我的关注(新)', '你可能感兴趣(推荐机构_关注)', '点击量'])
        if( pos == 3 ) _czc.push(['_trackEvent', '我的关注(新)', '关注的公司(未关注状态_公司关注)', '点击量'])
        if( pos == 4 ) _czc.push(['_trackEvent', '我的关注(新)', '关注的机构(未关注状态_机构关注)', '点击量'])
      } else {
        if(this.entitytype == 0) _czc.push(['_trackEvent', '我的关注(新)', '关注的公司(关注一览公司关注/取消)', '点击量'])
        else _czc.push(['_trackEvent', '我的关注(新)', '关注的机构(关注一览机构关注/取消)', '点击量'])
      }
      
      if(this.atten_item != '') {
        this.deleteSubscribe()
      } else {
        let arr = this.$store.state.attention.subscribe.filter(a => a.sub_type == this.entitytype)
        if(arr.length < 30) {
          this.addSubscribe()
        } else {
          this.haddleApplyTry('温馨提示', '最多关注30家'+(this.entitytype == 0 ? '公司' : '机构')+'，动脉橙机构版无限制，欢迎试用动脉橙机构版。', 25)
        }
      }
    },
    // 获取关注信息
    async getSubscribeList(callBack) {
      let res = await subscribeList({
        user_key: this.$store.state.user_key
      },(error) => {
        this.$Message.error('请求错误！')
      })
      if(res.status == 'success') {
        this.$store.commit('updateFilter', {
          g_relation:res.g_relation,
          group:res.group,
          subscribe:res.subscribe
        })
        if(callBack) callBack()
      } else {
        this.$Message.error(res.msg)
      }
    },
    async deleteSubscribe() {
      let res = await deleteSubscribe({
        user_key: this.$store.state.user_key,
        op_type: 'cancel',
        subscribe_id: this.atten_item.id
      }, (error) => {
        this.$Message.error('请求错误！')
      })
      if (res.status == 'success') {
        const cb = () => {
          this.$Message.success('取消成功！')
        }
        this.getSubscribeList(cb)
      } else {
        this.$Message.error(res.message)
      }
    },
    async addSubscribe () {
      let res = await addSubscribe({
        sub_type: this.entitytype,
        sub_type_id: this.item.id,
        user_key: this.$store.state.user_key
      }, (error) => {
        this.$Message.error('请求错误！')
      })
      if(res.status == 'success') {
        const cb = () => {
          this.$Message.success('关注成功！')
        }
        this.getSubscribeList(cb)
      } else {
        if(res.code == 2000) {
          this.haddleApplyTry('温馨提示', '最多关注30家'+(this.entitytype == 0 ? '公司' : '机构')+'，动脉橙机构版无限制，欢迎试用动脉橙机构版。', 25)
        } else {
          this.$Message.error(res.message)
        }        
      }
    },
  }
}

export { entity_temp_mixins }